<template>
  <div class="coin">
    <XR-head titleText="我的金币" :rightShow="false"></XR-head>
    <div class="total" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">金币总额</p>
      <p class="money">{{memberFinance.Coin.toFixed(2)}}</p>
    </div>
    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/usercenter/coinRecharge" v-if="false">
          <mu-list-item title="金币充值">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <router-link to="/usercenter/coinWithdraw" v-if="!closeCoinWithdraw">
          <mu-list-item title="金币提现">
            <mu-icon slot="left" value=":fa fa-withdraw"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/coinTransfer" v-if="isCoinTransfer">
          <mu-list-item title="金币转账">
            <mu-icon slot="left" value=":fa fa-transfer"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/coinStream">
          <mu-list-item title="金币查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      memberFinance :{
        Coin:0
      },
      siteConfig:{ MobileBgImage: '' }
    };
  },
  mounted :function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    this.getSiteInfo()
      this.getFinanceInfo()
  },
  methods: {
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getFinanceInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMemberFinanceAccount"
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.memberFinance = res.Data;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
.coin .total{
  padding: 20px 20px;
  overflow: hidden;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
}
.coin .title{
  line-height: 24px;
  font-size: 14px;
  color: white;
}
.coin .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
  color: white;
}
.coin .sub-nav{
  background: white;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/coin.vue